<div class="container footer" fxLayout="row wrap" fxLayout.lt-md="column" fxLayoutAlign="center center" fxLayoutGap="10px">

    <div fxFlex="100" fxFlex.gt-sm="50">
        <div fxLayout="row">
            <div fxFlex="100" fxFlexOffset="50px">
                <h4 style="margin-left: 30px;">Links</h4>
                <mat-list>
                    <mat-list-item routerLink="home" class="list"><a mat-button routerLinkActive="itemActive">Home</a></mat-list-item>
                    <mat-list-item routerLink="about" class="list"><a mat-button routerLinkActive="itemActive">About</a></mat-list-item>
                    <mat-list-item routerLink="menu" class="list"><a mat-button routerLinkActive="itemActive">Menu</a></mat-list-item>
                    <mat-list-item routerLink="contact" class="list"><a mat-button routerLinkActive="itemActive">Contact</a></mat-list-item>
                </mat-list>
            </div>
            <div fxFlex="100">
                <h4>Our Address</h4>
                <address style="font-size: 100%;font-weight: 400;">
              Srm University <br> Chennai, India<br>
              <a href="tel:6263804262"><i class="fa fa-phone"></i> : Phone<br></a>
            
              <i class="fa fa-envelope"></i>:
              <a href="mailto:pranjaypoddar@gmail.com">Email</a>
            </address>
            </div>
        </div>
    </div>
    <div fxFlex="100" fxFlex.gt-sm="45">
        <div style="text-align:center">

            <a mat-icon-button class="btn-github" href="https://github.com/pranjay-poddar"><i class="fa fa-github fa-lg"></i></a>
            <a mat-icon-button class="btn-linkedin" href="http://www.linkedin.com/in/pranjay-poddar"><i class="fa fa-linkedin fa-lg"></i></a>
            <a mat-icon-button class="btn-twitter" href="http://twitter.com/pranjaypoddar"><i class="fa fa-twitter fa-lg"></i></a>
            <a mat-icon-button class="btn-youtube" href="http://youtube.com/catalyticoriginals"><i class="fa fa-youtube fa-lg"></i></a>
            <a mat-icon-button class="btn-mail" href="mailto:pranjaypoddar@gmail.com"><i class="fa fa-envelope-o fa-lg"></i></a>
        </div>
    </div>
    <div>
        <p>© Copyright 2021 Red Sands Restaurant</p>
    </div>
</div>